import { useMemo } from 'react';
import { Link, ProductionBatchStatistics } from '@interfaces/search';
import { ncFileStatuses, withERP } from '@helpers';
import i18n from 'i18n-js';
import { getLinkText } from '@v2/pages/machines/modules/now/components/Overview/components/TopBlock/helpers';
import { useSelector } from 'react-redux';
import { selectIsWithERP } from '@reducers/membership';
import { selectSingleBatch } from '@reducers/batch';
import { selectSelectedItem } from '@reducers/machines';

const useManageLinkIconWithInfo = () => {
  const isWithERP = useSelector(selectIsWithERP);
  const batch: ProductionBatchStatistics = useSelector(selectSingleBatch);

  const machine = useSelector(selectSelectedItem);

  const ncFileStatus = machine?.machineStatus?.ncFileStatus;
  const { links, linkStatus, ncFileName } = batch || {};

  const linksHash = links?.map((l) => getLinkText(l)).join(' ');
  const withERPValue = withERP(isWithERP);

  const takeIntoAccountOnlyNcFileStatus =
    [ncFileStatuses.Ignored, ncFileStatuses.Change, ncFileStatuses.Unknown, ncFileStatuses.Setup].includes(ncFileStatus) ||
    (!withERPValue && ncFileStatus === ncFileStatuses.Linked);

  const shouldDisplayLinkIcon = takeIntoAccountOnlyNcFileStatus ? !!ncFileStatus : linkStatus || ncFileStatus;

  const linkText: string = useMemo(() => {
    if (takeIntoAccountOnlyNcFileStatus) {
      return `${i18n.t(`${ncFileStatus} NC File`)}`;
    }

    if (ncFileStatus === ncFileStatuses.Linked) {
      if (!withERPValue) {
        return ncFileName;
      }

      if (links?.length === 0) {
        return i18n.t('Not Linked To Job');
      }

      if (links?.length === 1) {
        return getLinkText(links[0]);
      }

      if (links?.length > 1) {
        return linksHash;
      }
    }

    return '';
  }, [ncFileStatus, withERPValue, ncFileName, linksHash]);

  return { linkText, takeIntoAccountOnlyNcFileStatus, shouldDisplayLinkIcon, withERPValue, linkStatus, ncFileStatus };
};

export { useManageLinkIconWithInfo };
